import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.INICIO.DASHBOARD]() {
        const {data} = await api.inicio.dashboard()
        return data
    },


    async [actionTypes.INICIO.BUSCAR_PACIENTES_AGENDADOS](context, input) {
        const {data} = await api.inicio.buscarPacientesAgendados(input)
        return data
    },

}